import React from 'react';
import ServiceAutoScalingChart from 'components/ClusterDetails/ClusterDetailsBody/ScalingConfigurations/ServiceAutoScalingChart/ServiceAutoScalingChart';
import { clusterScalingNode } from 'types/cluster';

type AnalyticsChartProps = {
  instanceId: string;
  clusterScalingNodes: clusterScalingNode[];
};
function AnalyticsChart({
  instanceId,
  clusterScalingNodes,
}: AnalyticsChartProps) {
  return (
    <ServiceAutoScalingChart
      chartService="analytics"
      instanceId={instanceId}
      clusterScalingNodes={clusterScalingNodes}
    />
  );
}

export default AnalyticsChart;
